import { render, staticRenderFns, recyclableRender, components } from "./u-toolbar.vue?vue&type=template&id=55c89db1&scoped=true&"
var renderjs
import script from "./u-toolbar.vue?vue&type=script&lang=js&"
export * from "./u-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./u-toolbar.vue?vue&type=style&index=0&id=55c89db1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c89db1",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-toolbar/u-toolbar.vue"
export default component.exports